
import './App.css'
import AppRouter from './AppRouter'
import { CssBaseline } from '@mui/material/'
import { ThemeProvider } from '@mui/material/styles'
import theme from './utils/theme'
import { AuthProvider } from './contexts/AuthContext'

function App() {
  return (
    <>
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="App">
          <AppRouter />
        </div>
      </ThemeProvider>
    </AuthProvider>
    </>
  )
}

export default App